import React, { useEffect } from 'react';
import { CreditCard } from 'lucide-react';
import StripePaymentForm from './StripePaymentForm';

/**
 * Payment Validation Modal
 * Shown when a free_user attempts to access a paid service without a payment method
 * Uses the consolidated StripePaymentForm component for secure payment method setup
 */
const PaymentValidationModal = ({ isOpen, onClose, onSuccess, redirectLocation = 'dashboard' }) => {
  // Scroll to top when modal opens
  useEffect(() => {
    if (isOpen) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSuccess = async (result) => {
    console.log('💳 Payment method saved successfully');
    
    // Call onSuccess callback if provided (parent handles closing, navigation, and toast)
    if (onSuccess) {
      console.log('💳 Calling onSuccess callback...');
      await onSuccess(result, redirectLocation);
    } else {
      // If no onSuccess callback, just close the modal
      onClose();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start sm:items-center justify-center z-50 overflow-y-auto p-2 sm:p-4 sm:pt-20">
      <div className="bg-white rounded-lg p-4 sm:p-6 md:p-8 max-w-md w-full my-4">
        <div className="flex items-center mb-4 sm:mb-6">
          <CreditCard className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 mr-2 sm:mr-3 flex-shrink-0" />
          <h3 className="text-base sm:text-lg md:text-xl font-bold break-words">Payment Required</h3>
        </div>
        
        <StripePaymentForm 
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          showUpgradeNotice={true}
        />
      </div>
    </div>
  );
};

export default PaymentValidationModal;
